export default () => ({
    newsletterMailingData: {},
    newsletterMailingIsLoaded: false,
    subscriberToken: null
})
